import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=7d495b24"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&id=7d495b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports